import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import NavBar, { NavBarItem } from "../../../components/NavBar";
import "./PrototypeShared.css";

const etapas = ["Chegou no armazém", "Em preparação", "Liberado", "Embarcado"];

interface CargaCliente {
  referencia: string;
  origem: string;
  etapaAtual: number; // índice em `etapas`
  pendenciaDocumental: boolean;
}

const cargas: CargaCliente[] = [
  { referencia: "CG-88213", origem: "Miami (MIA)", etapaAtual: 3, pendenciaDocumental: false },
  { referencia: "CG-88220", origem: "Cincinatti (CVG)", etapaAtual: 2, pendenciaDocumental: true },
  { referencia: "CG-88231", origem: "Los Angeles (LAX)", etapaAtual: 1, pendenciaDocumental: false },
  { referencia: "CG-88240", origem: "Chicago (ORD)", etapaAtual: 0, pendenciaDocumental: false },
];

/**
 * Protótipo da aposta 2: portal do cliente em tempo real. O papel ROLE_CLIENT já
 * existe no sistema hoje - essa tela ilustra o que substituiria o e-mail diário
 * (RelatorioDiario) por uma consulta ao vivo. Sem lógica de negócio nova.
 */
const PortalClienteView: React.FC = () => {
  const navItems: NavBarItem[] = [
    { label: "Início", route: "/", iconName: "house-door" },
    { label: "Iniciativas", route: "/iniciativas-estrategicas", iconName: "compass" },
  ];

  return (
    <Container fluid>
      <NavBar items={navItems} />
      <div className="mb-2"></div>

      <div className="proto-wrap">
        <Link to="/iniciativas-estrategicas" className="proto-back">← Iniciativas estratégicas</Link>

        <div className="proto-header">
          <div className="proto-badge">🧭 Protótipo — aposta 2 de 5</div>
          <h2>Portal do cliente em tempo real</h2>
          <p className="proto-subtitle">
            Hoje o cliente recebe um e-mail diário (RelatorioDiario) com o status. Aqui ele consulta ao vivo,
            sem esperar o próximo envio — o papel ROLE_CLIENT já existe no sistema hoje.
          </p>
        </div>

        <div className="proto-section-title">Minhas cargas — visão do cliente</div>
        <div className="proto-mock">
          <div className="proto-mock-bar">
            <div className="proto-mock-dot"></div><div className="proto-mock-dot"></div><div className="proto-mock-dot"></div>
            <span className="proto-mock-title">giantlog.giantcargo.com.br/portal-cliente</span>
          </div>
          <div className="proto-mock-body">
            {cargas.map((c) => (
              <div key={c.referencia} style={{ marginBottom: 20 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                  <div>
                    <span style={{ fontWeight: 700, fontFamily: "var(--mono)", fontSize: 12.5 }}>{c.referencia}</span>
                    <span style={{ color: "var(--sub)", fontSize: 12, marginLeft: 8 }}>{c.origem}</span>
                  </div>
                  {c.pendenciaDocumental && (
                    <span className="proto-pill proto-pill-warn">⚠️ Pendência documental</span>
                  )}
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {etapas.map((etapa, i) => (
                    <React.Fragment key={etapa}>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: "0 0 auto", width: 92 }}>
                        <div
                          style={{
                            width: 22, height: 22, borderRadius: "50%",
                            background: i <= c.etapaAtual ? "var(--accent)" : "var(--old)",
                            color: i <= c.etapaAtual ? "#fff" : "var(--sub)",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            fontSize: 11, fontWeight: 700,
                          }}
                        >
                          {i < c.etapaAtual ? "✓" : i + 1}
                        </div>
                        <span style={{ fontSize: 10, textAlign: "center", color: "var(--sub)", marginTop: 4 }}>{etapa}</span>
                      </div>
                      {i < etapas.length - 1 && (
                        <div style={{ flex: 1, height: 2, background: i < c.etapaAtual ? "var(--accent)" : "var(--old)", marginBottom: 16 }}></div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="proto-note">
          Dados ilustrativos. WareHouseClient já vincula qual usuário-cliente enxerga qual carga — a consulta ao
          vivo reaproveitaria esse mesmo relacionamento.
        </div>

        <div className="proto-footer-nav">
          <Link to="/iniciativas-estrategicas/torre-controle">← Torre de controle</Link>
          <Link to="/iniciativas-estrategicas/compliance-dgr">Próxima: Compliance e DGR →</Link>
        </div>
      </div>
    </Container>
  );
};

export default PortalClienteView;
